import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-117" data-mp="122dcx9d3pxct">
      <div className="mx-auto max-w-3xl px-5" data-id="element-118" data-mp="124g6u4hdkamt">
        <h2 id="faq-title" className="text-center font-display text-[30px] font-black leading-tight text-ink sm:text-[42px]" data-id="element-119" data-mp="1pt901t6m44dq">
          Frequently asked <em className="text-brand" data-id="element-120" data-mp="1ut52vp3kpprp">questions</em>
        </h2>

        <div className="mt-10 divide-y divide-line border-y border-line" data-id="element-121" data-mp="1g1mmhq6sxt7t">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-122" data-mp="28qtmyuptgsvp" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-id="element-123" data-mp="28pikcy83xr66">
                  <span className="text-[17px] font-bold leading-snug text-ink" data-id="element-124" data-mp="2jrxalqdruyix">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-125" data-mp="2ygk18o8uncpg" />
                </button>
                <AnimatePresence initial={false} data-id="element-126" data-mp="37evnke2onoc3">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-127" data-mp="32gu5nwgztv27">
                      <p className="pb-5 text-[16px] leading-relaxed text-muted" data-id="element-128" data-mp="1i220s4gb6moh">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10" data-id="element-129" data-mp="2bsaqzodal3mh">
          <CtaButton label="I'm ready — get instant access" caption="One-time payment of $27 · 7-day guarantee" data-id="element-130" data-mp="2btlv5pangde4" />
        </div>
      </div>
    </section>;
}